import React, { useRef } from 'react';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { Modal, Slider } from 'antd';

const ImageCrop: React.FC<{
    close: () => void;
    image: string;
    isOpen: boolean;
    upload: (file: File) => Promise<void>;
}> = ({ close, image, isOpen, upload }) => {
    const arrayOfInputRefs = useRef<any>([]);
    arrayOfInputRefs.current = React.createRef();

    const handleRotateCW = (val: number) => {
        const imageElement = arrayOfInputRefs.current?.current;
        const cropper = imageElement?.cropper;
        cropper.rotateTo(val);
    };

    const getCropBoxData = async () => {
        const imageElement = arrayOfInputRefs.current?.current;

        try {
            const base64Image = imageElement?.cropper?.getCroppedCanvas().toDataURL();
            if (base64Image) {
                const base64Response = await fetch(base64Image);
                const blob = await base64Response.blob();

                const file = new File([blob], 'header-footer', {
                    type: 'image/png',
                });

                upload(file);
                close();
            }
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Modal
            title="Crop Image"
            okText="Save"
            onOk={getCropBoxData}
            onCancel={close}
            destroyOnClose
            visible={isOpen}
        >
            <div>
                <div key={1}>
                    <Cropper
                        key={1}
                        crossOrigin="anonymous"
                        className="cropperContainer"
                        src={image}
                        style={{ height: 300, margin: '1rem' }}
                        guides={false}
                        checkCrossOrigin={false}
                        dragMode="move"
                        autoCrop={false}
                        ref={arrayOfInputRefs.current}
                        zoomOnWheel={true}
                        zoomable={true}
                        viewMode={0}
                        restore={false}
                    />
                </div>
                <div className="flex space-x-16">
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        className="w-16 fill-neutral-3"
                    >
                        <path d="M463.5 224H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1c-87.5 87.5-87.5 229.3 0 316.8s229.3 87.5 316.8 0c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0c-62.5 62.5-163.8 62.5-226.3 0s-62.5-163.8 0-226.3c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5z" />
                    </svg>
                    <Slider
                        min={0}
                        max={180}
                        step={1}
                        className="flex-1"
                        onChange={(val) => {
                            handleRotateCW(val);
                        }}
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        railStyle={{
                            background: '#cccfdb',
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};
export default ImageCrop;
